import axiosInstance from './axiosInstance';

const createReport = ({ type, options }) =>
  axiosInstance.post('/internal/admin/reports', { type, options });

export default createReport;
